<div class="projects-detail">

  <!-- Header -->
  <div class="row align-items-center">
    <div class="col">
      <h3 class="text-manax m-0 mb-3 d-flex justify-content-between align-items-center">
        <!-- Título a la izquierda -->
        <span class="text-purple-manax text-capitalize title-modal" #top>
          Proyecto <span *ngIf="project?.name">{{ project.name }}</span>
        </span>
        <!-- Botones a la derecha -->
        <span class="d-flex align-items-center">
          <button mat-raised-button type="button" class="btn btn-manax p-2 mr-2" [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()">
            <i class="material-icons">add</i> Añadir
          </button>
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openNewQuotesModal()">
              <span><i class="material-icons align-middle">request_quote</i> Presupuesto</span>
            </button>
            <button mat-menu-item (click)="openNewTaskModal('QUOTED')">
              <span><i class="material-icons align-middle">business_center</i> Trabajo</span>
            </button>
            <button mat-menu-item (click)="openNewBDocumentModal('INVOICE')">
              <span><i class="material-icons align-middle">paid</i> Factura</span>
            </button>
          </mat-menu>
        </span>
      </h3>
    </div>
  </div>


  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <!-- body content -->
  <div *ngIf="!loading" style="border-bottom: 1px solid #B1AFC1;"></div>
  <div *ngIf="!loading">
    <div class="row px-3 font-manax">
      <div class="col-12 pt-3">
        <div class="row px-0 text-purple-manax bold-item" style="font-size: 1.5rem;">
          Cliente:
          {{
          isClient(project.client)
          ? (project.client.firstname + ' ' + project.client.lastname)
          : project.client
          }}
        </div>
      </div>
    </div>

    <div class="row my-3 font-manax">
      <div class="col-8 pb-3">
        <div class="row">
          <div class="col-12">
            <h5 class="m-0">
              <b class="bold-item">Descripción:</b>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            {{project.description}}
          </div>
        </div>
      </div>

      <div class="col-4 pb-3">
        <div class="row">
          <div class="col-12">
            <h5 class="m-0">
              <b class="bold-item">Fecha:</b>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            {{dateFormated}}
          </div>
        </div>
      </div>
    </div>

    <!-- Task -->
    <div class="row my-3" style="border-bottom: 1px solid #B1AFC1;"></div>
    <div class="row my-3">
      <div class="col-12">
        <div class="row font-manax">
          <div class="col-12 pb-3">
            <h5 class="m-0">
              <b class="bold-item">{{tasks.length}}&nbsp;Trabajos:</b>
            </h5>
          </div>
        </div>

        <div class="row font-manax" *ngIf="tasks.length > 0 && !loadingTask">
          <div class="col-12 pb-3">
            <table class="table table-hover m-0 align-top">
              <tbody>
                <tr *ngFor="let task of tasks" class='cursor-pointer' (click)="openTasksModal(task)">
                  <td>
                    {{task?.scheduledStart | date:'dd/MM/yyyy HH:mm'}}
                  </td>

                  <td class="bold-item">
                    {{task?.title ? task?.title +' / '+ task?.category[0].name : task?.category[0].name}}
                  </td>
                  <td>
                    <span class="status-pill status-label"
                      [ngStyle]="{'background-color': taskStatusColors[task?.status] || taskStatusColors.DEFAULT}">
                      {{taskStatuses[task?.status]}}
                    </span>
                  </td>
                  <td class="text-right">
                    <div *ngIf="task?.workers && task?.workers?.length === 0">
                      Sin Trabajador Asignado
                    </div>
                    <div *ngIf="task?.workers && task?.workers?.length > 0">
                      Asignado a
                      <span *ngFor="let worker of task.workers; let isLast=last">
                        &nbsp;{{worker?.firstname}} {{worker?.lastname}}{{!isLast ? ', ' : ''}}
                      </span>
                    </div>
                  </td>
                </tr>

                <tr class='cursor-pointer' *ngIf="thereAreMoreTask" (click)='loadMoreTask()'>
                  <td colspan="12">
                    <button class="btn btn-link text-purple-manax text-capitalize p-0">
                      + cargar mas</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="loadingTask">
          <div class="d-flex justify-content-center align-items-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Quote -->
    <div class="row my-3" style="border-bottom: 1px solid #B1AFC1;"></div>
    <div class="col-12 p-0">
      <div class="row font-manax">
        <div class="col-12 pb-3">
          <h5 class="m-0">
            <b class="bold-item">{{quotes.length}}&nbsp;Presupuestos:</b>
          </h5>
        </div>
      </div>

      <div class="row font-manax" *ngIf="quotes.length > 0">
        <div class="col-12 pb-3">
          <table class="table table-hover m-0 align-top">
            <thead class="text-manax">
              <tr>
                <!-- PC -->
                <th class="d-none d-md-table-cell align-top" style="width: 150px;">Nº<br></th>
                <th class="align-top" style="height: 65px; position: relative; max-width: 1000px;">Estado<br></th>
                <th class="d-none d-md-table-cell align-top">Cliente<br></th>
                <th class="d-none d-md-table-cell align-top">Fecha Emisión<br></th>
                <th class="d-none d-md-table-cell align-top">Fecha Vto.<br></th>
                <th class="d-none d-md-table-cell align-top text-right">Total<br></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let quote of quotes" [class.text-danger]="quote.isDeleted" class='cursor-pointer'
                (click)="openQuotesModal(quote)">
                <!-- PC -->
                <td class="d-none d-md-table-cell">{{quote.number ?? ' - ' }}</td>
                <td class="d-none d-md-table-cell p-1">
                  <div class="text-center py-1 status-pill status-label"
                    [ngStyle]="{'background-color': quoteStatusColors[quote?.status]}">
                    {{ quoteStatuses[quote?.status] }}
                  </div>
                </td>
                <td class="d-none d-md-table-cell bold-item">{{quote.client?.firstname}} {{quote.client?.lastname}}</td>
                <td class="d-none d-md-table-cell">{{quote.date | date:'dd/MM/yyyy':'UTC'}}</td>
                <td class="d-none d-md-table-cell">{{quote.dueDate | date:'dd/MM/yyyy':'UTC'}}</td>
                <td class="d-none d-md-table-cell text-right bold-item">{{quote.total | money: { needSymbol:true } }}
                </td>

                <!-- Mobile -->
                <td class="d-table-cell d-md-none" style="line-height: 14px;">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-8 col-sm-6">
                        <div class="row mb-2 pr-3">
                          <b class="bold-item">
                            N°: {{quote.number ?? ' - ' }}
                          </b>
                        </div>
                        <div class="row mb-2 pr-3">
                          {{quote.client.firstname}} {{quote.client.lastname}}
                        </div>
                        <div class="row mb-2 pr-3">
                          Emisión: {{quote.date | date:'dd/MM/yyyy'}}
                        </div>
                        <div class="row pr-3">
                          Vto: {{quote.dueDate | date:'dd/MM/yyyy'}}
                        </div>
                      </div>
                      <div class="col-4 col-sm-6 d-flex flex-column align-items-center justify-content-center p-0">
                        <div class="row mb-2 bold-item">
                          {{quote.total | money: { needSymbol:true } }}
                        </div>
                        <div class="row">
                          <div class="text-center py-1 status-pill text-white"
                            style="border-radius: 15px; font-weight: 600; padding: 5px 5px; color: white; font-size: 13px;"
                            [ngStyle]="{'background-color': quoteStatusColors[quote?.status]}">
                            {{ quoteStatuses[quote?.status] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <!-- All  -->
              <tr class='cursor-pointer' *ngIf="thereAreMoreQuotes" (click)='loadMoreQuotes()'>
                <td colspan="12">
                  <button class="btn btn-link text-purple-manax text-capitalize p-0">
                    + cargar mas</button>
                </td>
              </tr>
          </table>
        </div>

        <div *ngIf="loadingQuotes">
          <div class="d-flex justify-content-center align-items-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Invoice -->
    <div class="row my-3" style="border-bottom: 1px solid #B1AFC1;"></div>
    <div class="col-12 p-0">
      <div class="row font-manax">
        <div class="col-12 pb-3">
          <h5 class="m-0">
            <b class="bold-item">{{invoices.length}}&nbsp;Facturas:</b>
          </h5>
        </div>
      </div>

      <div class="row font-manax" *ngIf="invoices.length > 0">
        <div class="col-12 pb-3">
          <table class="table table-hover m-0 align-top">
            <thead class="text-lavuro">
              <tr>
                <!-- PC -->
                <th class="align-top d-none d-md-table-cell">N°<br></th>
                <th class="align-top d-none d-md-table-cell"
                  style="height: 65px; position: relative; max-width: 1000px;">
                  Estado<br> <br>
                </th>
                <th class="align-top d-none d-md-table-cell">Cliente<br></th>
                <th class="align-top d-none d-md-table-cell" width="150px">Fecha Emisión<br></th>
                <th class="align-top d-none d-md-table-cell" width="150px">Fecha Vto.<br></th>
                <th class="align-top d-none d-md-table-cell text-right"
                  style="height: 65px; position: relative; max-width: 1000px;">
                  Total<br>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let document of invoices"
                [class.text-danger]="document.isDeleted || document.status == invoiceStatuses.CANCELLED"
                class='cursor-pointer' (click)="openEditDocument(document)">

                <!-- PC -->
                <td class="d-none d-md-table-cell">
                  {{ document.serie != invoiceStatuses.DRAFT ? document.serieAndNumber || document.docNumber :
                  "" }}
                </td>
                <td class="p-1 d-none d-md-table-cell" width="200px">
                  <div class="text-center py-1 status-pill text-white"
                    [ngStyle]="{'background-color': invoiceStatusesColors[document.status] || invoiceStatusesColors.ISSUED}">
                    <!-- [class.text-white]="document.isDeleted || document.status == invoiceStatuses.CANCELLED"> -->
                    {{invoiceStatusesLabels[document.status] || invoiceStatusesLabels.ISSUED}}
                  </div>
                </td>
                <td class=" bold-item d-none d-md-table-cell">
                  {{document.client.firstname}} {{document.client.lastname}}
                </td>
                <td class="l text-center d-none d-md-table-cell" width="150px">
                  {{document.date | date:'dd/MM/yyyy'}}</td>
                <td class=" text-center d-none d-md-table-cell" width="150px">
                  {{document.dueDate | date:'dd/MM/yyyy'}}
                  <span *ngIf="document.overdue"><b class="overdue">&nbsp;Vencida</b></span>
                </td>
                <td class="bold-item text-right d-none d-md-table-cell">{{document.total
                  |
                  money: { needSymbol:true } }}
                  &nbsp;&nbsp;</td>

                <!--td class="d-none d-md-table-cell">
                          <span *ngIf="!document.isDeleted">No</span>
                          <span *ngIf="document.isDeleted">Si</span>
                        </td-->

                <!-- Mobile -->
                <td class="d-table-cell d-md-none" style="line-height: 14px;">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-8 col-sm-6">
                        <div class="row mb-2">
                          <b class="bold-item">
                            {{document.serie != invoiceStatuses.DRAFT ? "#" + (document.serieAndNumber ||
                            document.docNumber) :
                            "" }} <br *ngIf="document.serie != invoiceStatuses.DRAFT">
                          </b>
                        </div>
                        <div class="row mb-2">
                          {{document.client.firstname}} {{document.client.lastname}}
                        </div>
                        <div class="row mb-2">
                          fch:{{document.date | date:'dd/MM/yyyy'}}
                        </div>
                        <div class="row">
                          Vto:{{document.dueDate | date:'dd/MM/yyyy'}}
                        </div>
                      </div>
                      <div class="col-4 col-sm-6 d-flex flex-column align-items-center justify-content-center p-0">
                        <div class="row mb-2">
                          {{document.total | money: { needSymbol:true } }}
                        </div>
                        <div class="row mb-2">
                          <div class="text-center"
                            style="border-radius: 15px; font-weight: 600; padding: 5px 20px; color: white; font-size: 13px;"
                            [ngStyle]="{'background-color': invoiceStatusesColors[document.status] || invoiceStatusesColors.ISSUED}"
                            [class.text-white]="document.isDeleted || document.status == invoiceStatuses.CANCELLED">
                            {{invoiceStatusesLabels[document.status] || invoiceStatusesLabels.ISSUED}}
                          </div>
                        </div>
                        <div class="row">
                          <b class="overdue" *ngIf="document.overdue">Vencida</b>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <!-- All  -->
              <tr *ngIf="thereAreMoreInvoices">
                <td colspan="10">
                  <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMoreInvoices()'>
                    + cargar mas
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="loadingInvoices">
          <div class="d-flex justify-content-center align-items-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Delivery Note -->
  <div class="row my-3" style="border-bottom: 1px solid #B1AFC1;"></div>
  <div class="col-12 p-0">
    <div class="row font-manax">
      <div class="col-12 pb-3">
        <h5 class="m-0">
          <b class="bold-item">{{deliveryNotes.length}}&nbsp;Albaranes:</b>
        </h5>
      </div>
    </div>

    <div class="row font-manax" *ngIf="deliveryNotes?.length || 0 > 0">
      <div class="col-12 pb-3">
        <table class="table table-hover m-0 align-top">

          <thead class="text-manax">
            <tr>
              <!-- PC -->
              <th class="d-none d-md-table-cell align-top">N°<br></th>
              <th class="d-none d-md-table-cell align-top">Cliente<br></th>
              <th class="d-none d-md-table-cell align-top" width="150px">Fecha Emisión<br></th>
              <th class="d-none d-md-table-cell" width="1%">
                Firmado<br>
              </th>
              <th class="d-none d-md-table-cell" width="1%">
                Facturado<br>
              </th>
              <th class="d-none d-md-table-cell align-top text-right">Total<br></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let deliveryNote of deliveryNotes" [class.text-danger]="deliveryNote?.isDeleted"
              class='cursor-pointer' (click)="openDeliveryNote(deliveryNote)">

              <!-- PC -->
              <td class="d-none d-md-table-cell">{{deliveryNote?.serieAndNumber}}</td>
              <td class="d-none d-md-table-cell">{{deliveryNote?.client?.lastname}} {{deliveryNote?.client?.firstname}}
              </td>
              <td class="d-none d-md-table-cell">{{deliveryNote?.date | date:'dd/MM/yyyy'}}</td>
              <td class="d-none d-md-table-cell">{{deliveryNote?.isSigned ? 'Sí': 'No'}}</td>
              <td class="d-none d-md-table-cell">{{deliveryNote?.isInvoiced ? 'Sí': 'No'}}</td>
              <td class="d-none d-md-table-cell text-right">{{deliveryNote?.total | money: { needSymbol:true } }}</td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="col-12">
                  <div class="row">
                    <div class="col-8 col-sm-6">
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">
                          {{deliveryNote?.number ? deliveryNote?.serieAndNumber : '' }} -
                          {{deliveryNote?.client?.firstname}} {{deliveryNote?.client?.lastname}}
                        </b>
                      </div>
                      <div class="row mb-2 pr-3">
                        Emisión: {{deliveryNote?.date | date:'dd/MM/yyyy'}}
                      </div>
                      <div class="row pr-3">
                        Total: {{deliveryNote?.total | money: { needSymbol:true } }}
                      </div>
                    </div>
                    <div class="col-4 col-sm-6 d-flex flex-column align-items-center justify-content-center p-0">
                      <div class="row mb-2">
                        Firmado: {{deliveryNote?.isSigned ? 'Sí': 'No'}}
                      </div>
                      <div class="row">
                        Facturado: {{deliveryNote?.isInvoiced ? 'Sí': 'No'}}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>

            <!-- All  -->
            <tr *ngIf="thereAreMoreDeliveryNotes">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMoreDeliveryNotes()'>+
                  cargar
                  mas</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="loadingDeliveryNotes">
        <div class="d-flex justify-content-center align-items-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Attached -->
  <div class="row my-3" style="border-bottom: 1px solid #B1AFC1;"></div>
  <div class="col-12 p-0">
    <div class="row font-manax">
      <div class="col-12 pb-3">
        <h5 class="m-0">
          <b class="bold-item">{{attachments.length}}&nbsp;Adjuntos:</b>
        </h5>
      </div>
    </div>

    <div class="row font-manax" *ngIf="attachments.length > 0">
      <div class="col-12 pb-3">
        <table class="table table-hover m-0 align-top">
          <thead class="text-manax">
            <tr>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top">
                Cliente<br>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Trabajo<br>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Fecha<br>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Trabajador<br>
              </th>
              <th class="d-none d-md-table-cell align-top" style="max-width: 300px;">
                Nota
              </th>
              <th class="d-none d-md-table-cell align-top">
                <i class="material-icons">attach_file</i>
              </th>
              <!-- All -->
              <th class="d-none d-md-table-cell td-actions text-right p-0">
              </th>
            </tr>
          </thead>

          <tbody>
            <!-- default: future tasks, past or current with tracking ok -->
            <!-- primary: past with tracking null or delayed, or current with tracking delayed -->
            <!-- danger: current with tracking null -->
            <tr *ngFor="let comment of attachments" [class.text-danger]="comment.isDeleted">

              <!-- PC -->
              <td class="d-none d-md-table-cell field-container" (click)="openClientModal(comment.client)"
                *ngIf="comment.task && comment.client">
                {{comment.client?.firstname}} {{comment.client?.lastname}}
                <i class="material-icons small">launch</i>
              </td>
              <td class="d-none d-md-table-cell field-container" *ngIf="!comment.task || !comment.client">
                - trabajo eliminado -
              </td>

              <td class="d-none d-md-table-cell field-container" *ngIf="comment.task"
                (click)="openTaskModal(comment.task)">
                {{comment.task?.title}} -
                <span *ngFor="let category of comment.task?.category">
                  {{category.name}}.&nbsp;
                </span>
                <i class="material-icons small">launch</i>
              </td>
              <td class="d-none d-md-table-cell field-container" *ngIf="!comment.task">
                - trabajo eliminado -
              </td>

              <td class="d-none d-md-table-cell">{{comment.createdAt | date:'dd/MM/yyyy HH:mm'}}</td>

              <td class="d-none d-md-table-cell field-container" (click)="openWorkerModal(comment.worker)">
                {{comment.worker?.firstname}} {{comment.worker?.lastname}}
                <i class="material-icons small">launch</i>
              </td>

              <td class="d-none d-md-table-cell" style="max-width: 300px;">{{comment.comment}}</td>
              <td class="d-none d-md-table-cell">
                <ng-container *ngFor="let file of comment.attachments">
                  <!-- Validar luego si es una imagen con todos sus tipos de formato o no -->
                  <img *ngIf="(file.fileUrl).substring(file.fileUrl.length - 3) !== 'pdf'"
                    class="image-preview cursor-pointer" [src]="file.fileUrl" (click)="openFile(file)" />
                  <img *ngIf="(file.fileUrl).substring(file.fileUrl.length - 3) == 'pdf'"
                    class="image-preview cursor-pointer" src="/assets/img/pdf-image.png" (click)="openPdf(file)" />
                </ng-container>
              </td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="col-12">
                  <div class="row">
                    <div class="col-4">
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">
                          {{comment.worker?.firstname}} {{comment.worker?.lastname}}
                        </b>
                      </div>
                      <div class="row mb-2 pr-3">
                        {{comment.createdAt | date:'dd/MM/yyyy'}} a las {{comment.createdAt | date:'HH:mm'}}
                      </div>
                      <div class="row mb-2 pr-3">
                        Cliente: {{comment.client?.firstname}} {{comment.client?.lastname}}
                      </div>
                      <div class="row pr-3">
                        Trabajo: {{comment.task?.title}}
                      </div>
                    </div>
                    <div class="col-4 d-flex flex-column align-items-center justify-content-center p-0">
                      <div class="row pl-3">
                        {{comment.comment}}
                      </div>
                    </div>
                    <div class="col-4 d-flex flex-column align-items-center justify-content-center p-0">
                      <div class="row pl-3">
                        <ng-container *ngFor="let file of comment.attachments">
                          <img class="image-preview cursor-pointer" [src]="file.fileUrl" (click)="openFile(file)" />
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
              </td>
            </tr>

            <!-- All -->
            <tr *ngIf="thereAreMoreAttachments">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMoreAttachments()'>+
                  cargar
                  mas</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="loadingAttachments">
        <div class="d-flex justify-content-center align-items-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Expenses -->
  <div class="row my-3" style="border-bottom: 1px solid #B1AFC1;"></div>
  <div class="row font-manax py-3">
    <div class="col-12">
      <h5 class="m-0 title-section">
        Gastos
      </h5>
    </div>

    <div class="col-12">
      <app-detail-list-expenses [items]="project.expenses || []" [readOnly]="true" [pricing]="true"
        [taxPercentage]="false || 0"></app-detail-list-expenses>
    </div>
  </div>
</div>